import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { User, ChevronRight, ChevronDown } from "lucide-react";
import UserProfile from "../UserProfile";
import LogoSUBEBlanco from "./LogoSUBEBlanco";

const Navbar = ({ onToggleMobile, mobileOpen = false }) => {
  const userProfile = UserProfile.getInstance();
  const username = userProfile.getUserInfo()?.user ?? "";
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar col-lg-12 col-12 p-lg-0 fixed-top d-flex flex-row">
      <div className="navbar-menu-wrapper d-flex align-items-center">
        {/* Hamburger — visible solo en mobile ≤991px via CSS */}
        <button
          className="navbar-hamburger"
          onClick={onToggleMobile}
          aria-label="Abrir menú de navegación"
          aria-expanded={mobileOpen}
          type="button"
        >
          <i className="mdi mdi-menu" />
        </button>

        {/* Left section */}
        <div style={{ flex: 1 }}>
          {/* <h1 style={{ color: 'white', fontSize: '24px', margin: 0, whiteSpace: 'nowrap' }}>
            Control SUBE
          </h1> */}
        </div>

        {/* Logo centrado */}
        <div className="d-flex justify-content-center">
          <LogoSUBEBlanco className="navbar-logo-sube" />
        </div>

        {/* User menu */}
        <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
        <ul className="navbar-nav navbar-nav-right">
          <li className="nav-item nav-profile border-0">
            <Dropdown align="end" onToggle={setIsOpen}>
              <Dropdown.Toggle
                className="nav-link border-0 bg-transparent p-0 d-flex align-items-center"
                style={{ gap: '10px', outline: 'none', boxShadow: 'none' }}
              >
                {/* Avatar circle */}
                <div style={{
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  background: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  color: '#00477C',
                }}>
                  <User size={20} aria-hidden="true" />
                </div>
                {/* Username — oculto en tablet/mobile */}
                <span className="d-none d-lg-inline" style={{ color: 'white', fontSize: '0.875rem', fontWeight: 500 }}>
                  {username}
                </span>
                <span className="d-none d-lg-inline">
                  {isOpen
                    ? <ChevronDown size={16} style={{ color: 'white' }} aria-hidden="true" />
                    : <ChevronRight size={16} style={{ color: 'white' }} aria-hidden="true" />
                  }
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="navbar-dropdown"
                style={{
                  minWidth: '210px',
                  border: '1px solid #e5e7eb',
                  borderRadius: '0.5rem',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
                  padding: '4px 0',
                  marginTop: '10px',
                }}
              >
                {/* User info header */}
                <div style={{ padding: '12px 16px', borderBottom: '1px solid #f5f5f5' }}>
                  <p style={{ fontWeight: 600, color: '#1a1a1a', marginBottom: 0, fontSize: '0.875rem' }}>
                    {username}
                  </p>
                </div>

                {/* Logout */}
                <Dropdown.Item
                  className="d-flex align-items-center"
                  style={{ padding: '10px 16px' }}
                  onClick={() => userProfile.getUserInfo()?.logout?.()}
                >
                  <i className="mdi mdi-power mr-2" style={{ color: '#dc2626', fontSize: '1.1rem' }} />
                  <span style={{ color: '#dc2626', fontSize: '0.875rem' }}>Cerrar sesión</span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </li>
        </ul>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;
